<template>
  <div id="app">
    <div id="nav">
    	<router-link to="/"></router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>

export default {
  name:'App',
  
  created() {
  	console.log('app created function')
  	
  },
  
  mounted() {
  	console.log('app mounted function')
  },
  
  methods: {
  	
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
